import { environment } from './../../environments/environment';
import { TokenService } from './token.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Cliente } from './../models/cliente';
import { Observable } from 'rxjs';
import { Storage } from '@ionic/storage';
import moment from 'moment';
import { AlertController } from '@ionic/angular';
import { NavController } from '@ionic/angular';


@Injectable({
  providedIn: 'root'
})
export class ClienteService {
  static idusuario: any;
  static edad: number;
  static banda: string;
  static sexo: number;
  constructor(private httpClient: HttpClient,
    private navCtrl: NavController,
    private tokenService: TokenService, private storage: Storage, private alertController: AlertController) { }

  //Este metodo sirve para mostrar un cliente, no necesita concatenar el id del cliente,
  //aunque no lo pida  otra opcion :`obtenerCliente/${id}`
  public obtCliente(id: number): Observable<Cliente> {
    // Declarar Variables
    // const cliente = this.httpClient.get<Cliente>(environment.global + 'alpha/obtenerCliente/' +
    //   this.tokenService.getUserName());
    const url = environment.global + 'alpha/obtenerCliente/' + this.tokenService.getUserName();
    let intentos = 0;
    const maxIntentos = 3;

    // Sin Alerta
    // cliente.subscribe((data)=>{
    //   const id = ClienteService.idusuario = data.idCliente;
    //   ClienteService.edad =moment().diff(moment(data.fechaNacimiento),'years');
    //   ClienteService.banda = data.idComplexBand;
    //   ClienteService.sexo=data.idSexo;
    //   this.storage.set('datosCliente',data);
    //   this.storage.set('idCliente',id);
    // });
    // return cliente; //'obtenerCliente' + this.TokenService.getUserName()
    // //+ this.TokenService.getUserName
    const clienteObservable = new Observable<Cliente>((observer) => {
      const intentar = () => {
        this.httpClient.get<Cliente>(url).subscribe({
          next: (data) => {
            const id = ClienteService.idusuario = data.idCliente;
            ClienteService.edad = moment().diff(moment(data.fechaNacimiento), 'years');
            ClienteService.banda = data.idComplexBand;
            ClienteService.sexo = data.idSexo;
            this.storage.set('datosCliente', data);
            this.storage.set('idCliente', id);
            observer.next(data);
            observer.complete();
          },
          error: (err) => {
            intentos++;
            if (intentos < maxIntentos) {
              setTimeout(() => intentar(), 1000); // Espera 1 segundo antes de reintentar
            } else {
              observer.error(err);
              if (!localStorage.getItem('alertaCliente')) {
                // Si no se ha mostrado la alerta, mostrarla
                console.error("Error al obtener el cliente:", err);
                console.log("Mostrando alerta de error de conexión.");
                this.alerta();
                // Bandera para comprobar que ya se mostro solo una vez la alerta.
                localStorage.setItem('alertaCliente', 'true');
              }
              observer.complete();
              return;
            }
          }
        });
      };
      intentar();
    });

    return clienteObservable;

  }
  public async cargarCliente(): Promise<Cliente> {
    return await this.storage.get('idCliente');
  }
  public async cargarDatosCliente(): Promise<Cliente> {
    return await this.storage.get('datosCliente');
  }

  async cerrarSesion() {
    try {
      const response = await this.tokenService.logOut();
      console.log("Respuesta del servidor al cerrar sesión:", response);
      localStorage.setItem('ingresado', 'false');
      console.log("Usuario deslogueado de la app.");
      this.navCtrl.navigateRoot('/login');
      console.log("Redireccionando a la página de login.");
      console.log("Usuario deslogueado de las notificaciones.");
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  }


  // Método para solicitar permiso de notificaciones
  async alerta(): Promise<void> {
    const alert = await this.alertController.create({
      header: 'Intenta nuevamente',
      message: 'No fue posible autenticarte en este momento.',
      buttons: [
        {
          text: 'Cerrar Sesion',
          role: 'cancel',
          handler: () => {
            // Cerrar Sesion
            this.cerrarSesion().then(() => {
              console.log("Sesion Finalizada y redireccionando al login.");
            }).catch(error => {
              console.error("Error al cerrar sesión:", error);
            });
          }
        }
      ]
    });
    await alert.present();
    const { role } = await alert.onDidDismiss();
  }

}
